// Modify header & footer pdf
// React
import { useContext } from "react"

// Components
import { Button, Card, FooterMenu, HeaderMenu } from "components"
import { ChildItem } from "./components"
import { PdfLinkAccount } from "../components"

// Utils
import { dataAccountLink, exportExcel, Render, RenderProvider } from "./utils"
import { exportPdf } from "utils"
import { LinkAccountContext, LinkAccountProvider } from "pages/Setup/contexts"

export default function LinkAccount() {
  return (
    <RenderProvider>
      <LinkAccountProvider>
        <section className="container pt-5  gap-5 flex flex-col">
          <HeaderMenu title="GENERAL LINK ACCOUNT">
            {/* <a
            href="#"
            target="_blank"
          > */}
            <Button color="primary">TUTORIAL</Button>
            {/* </a> */}
          </HeaderMenu>

          <Card>
            <Card.Body>
              <div className="overflow-x-auto">
                <TableContent />
              </div>
            </Card.Body>
          </Card>

          <Footer />
        </section>
      </LinkAccountProvider>
    </RenderProvider>
  )
}

function TableContent() {
  const { render } = useContext(Render)

  if (render) {
    return <ChildItem />
  } else {
    return <div />
  }
}


function Footer(): JSX.Element {

  const { data } = useContext(LinkAccountContext)

  return (
    <FooterMenu
      export={{
        actiontype: "export",
        onClick: () => exportExcel({
          dataHeader: dataAccountLink,
          data
        })
      }}
      pdf={{
        actiontype: "pdf",
        onClick: () => {
          exportPdf({
            documentComponent: <PdfLinkAccount
              dataLinkAccount={dataAccountLink}
              dataList={data}
              title="General Link Account "
            />,
            fileName: "Link Account"
          })
        }
      }}
    />
  )
}